import React, { type FC } from 'react';
import { Box, Loader } from '@wix/design-system';

interface FullScreenLoaderProps {
  label: string;
}

export const FullScreenLoader: FC<FullScreenLoaderProps> = ({ label }) => (
  <Box
    direction="vertical"
    align="center"
    verticalAlign="middle"
    gap="SP2"
    height="100vh"
    width="100%"
    position="fixed"
    style={{ top: 0, left: 0, backgroundColor: 'white', zIndex: 9999 }}
  >
    <Loader text={label} />
  </Box>
);
